import type { CoreFetch } from '~/types/CoreFetch'

export const provideJoinWaitList = (coreFetch: CoreFetch) => {
  return function () {
    return coreFetch.$post<{ status: 'success'; created: boolean }>(
      '/subscription/wait_list/join',
    )
  }
}
